import React from "react";

function PromotersCard({ name, link, subs}) {
  // Determine the platform logo
  let platformLogo = null;

  if (link.includes("youtube.com")) {
    platformLogo = "https://rhkocjboresyvsbnwsfe.supabase.co/storage/v1/object/public/logos/yt.png";
  } else if (link.includes("kick.com")) {
    platformLogo = "https://rhkocjboresyvsbnwsfe.supabase.co/storage/v1/object/public/logos/kick.png";
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="cursor-pointer bg-neutral-800 rounded-lg w-full p-4 flex flex-col items-center 
                 transition transform hover:-translate-y-1 hover:shadow-lg 
                 hover:bg-neutral-700 "
    >
      <div className="w-12 h-12 mb-2 flex items-center justify-center rounded-full bg-neutral-600 overflow-hidden">
        {platformLogo ? (
          <img
            src={platformLogo}
            alt={`${name} platform logo`}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="text-white text-2xl">
            {/* Default icon if no specific platform */}
            <i className="fas fa-user" />
          </div>
        )}
      </div>
      <div className="flex flex-col items-center">
        <h2 className="text-sm font-semibold text-center text-white truncate">
          {name}
        </h2>
        {subs && (
          <span className="text-sm tracking-tight font-normal text-white opacity-60">
            ({subs})
          </span>
        )}
      </div>
    </a>
  );
}

export default PromotersCard;
